import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { lower } from "change-case";
import { Form, reduxForm, getFormValues, SubmissionError } from "redux-form";
import { Field } from "redux-form";
import { Button, Icon, Breadcrumb, Confirm } from "semantic-ui-react";
import FieldInput, { InputType as type } from "components/SemanticForm";
import { scrollToFirstValidateFailElement } from "core/utilities";
import { validations, validateCase as vCase } from "core/validate";
import { CancelPRContainer } from "./styled";
import { getHrmsMembers } from "ducks/member";
import { cancelPr, cancelPrAndSap } from "ducks/support";
import { MainBodyContent } from "components";
import {
  supportForUserPath,
  prMainSupportForUserPath,
  purchaseRequisitionDetailPath,
} from "routes";
import { getPRDetailByDocNo,clearPRCancelDetail } from "ducks/purchaseRequisition";

const CancelPR = (props) => {
  const { members, memberLoading, reset, history, prData } = props;
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    props.getHrmsMembers();
    return () => {
      props.clearPRCancelDetail();
    };
  }, []);

  const memberOptions = members.map((m) => ({
    value: lower(m.username),
    text: `${m.firstnameEn} ${m.lastnameEn}`,
  }));

  function submitAction() {
    setShowConfirm(false);
    props.cancelPrAndSap(props.valueForm, reset);
  }

  function LoadPRInfo(data) {
    const docNumber = data?.documentNumber;

    if (!docNumber || docNumber.trim() === "") {
      alert("Please input PR Document Number first.");
      return;
    }

    props.getPRDetailByDocNo(docNumber);
  }

  return (
    <MainBodyContent
      headerTitle="Cancel Purchase Requisition (Cancel PR)"
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: "Support",
              content: "Support",
              link: true,
              onClick: () => {
                history.push(supportForUserPath);
              },
            },
            {
              key: "pr",
              content: "Purchase Requisition (PR)",
              link: true,
              onClick: () => {
                history.push(prMainSupportForUserPath);
              },
            },
            {
              key: "cancelpr",
              content: "Cancel Purchase Requisition (Cancel PR)",
              active: true,
            },
          ]}
        />
      }
    >
      <CancelPRContainer>
        <div className="warnningMSG">
          <b>
            Warning! การยกเลิก PR ผ่านระบบ EzProcure ระบบจะยกเลิกใน SAP
            อัตโนมัติ กรณียกเลิกผิดต้องดำเนินการเปิด PR ใหม่เท่านั้น
          </b>
          <div>เงื่อนไขในการยกเลิก PR ต้องตรวจสอบดังนี้</div>
          <ul>
            <li>1. สถานะของ PR จะต้อง Completed เท่านั้นและ ต้องแจ้งจัดซื้อให้รับทราบก่อนการยกเลิกทุกกรณี</li>
            <li>
              2. ตรวจสอบ PR ในระบบ SAP จะต้องไม่มีการสร้าง RFQ หรือ PO (T-Code
              ME53N {">"} ระบุเลข PR SAP {">"} Tab Status)
            </li>
            <li>3. ตรวจสอบเลขเอกสารให้ถูกต้องกด Save</li>
          </ul>
        </div>
        <Form>
          <div className="rowFields">
            <Field
              name="documentNumber"
              label="PR Document Number"
              type={type.text}
              component={FieldInput}
              className="halfRow"
              require
            />
            <div className="collectiveButtons">
              <Button
                type="button"
                color="blue"
                onClick={() => LoadPRInfo(props.valueForm)}
              >
                Load Data
              </Button>
            </div>
            {Object.keys(prData || {}).length > 0 && (
              <div style={{ alignSelf: "center", paddingLeft: "10px" }}>
                <a
                  href={purchaseRequisitionDetailPath(prData?.id)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: "5px", fontSize: "1.3rem" }}
                >
                  Details
                </a>
              </div>
            )}
          </div>
          <div className="rowFields">
            <Field
              name="requesterCancel"
              label="Requester (User request cancel document)"
              loading={memberLoading}
              options={memberOptions}
              type={type.select}
              component={FieldInput}
              require
            />
            <Field
              name="sapNumber"
              label="PR SAP Number"
              type={type.text}
              component={FieldInput}
              editable={false}
            />
          </div>
          <div className="rowFields">
            <Field
              name="reason"
              label="Reason"
              type={type.textArea}
              component={FieldInput}
              require
            />
          </div>
          <div className="btnContainer">
            <Button
              type="button"
              content="Submit"
              color="blue"
              icon="paper plane outline"
              labelPosition="right"
              style={{ marginRight: "5px" }}
              onClick={() => setShowConfirm(true)}
            />
          </div>
          <Confirm
            size="mini"
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />
        </Form>
      </CancelPRContainer>
    </MainBodyContent>
  );
};

const mapStateToProps = (state) => {
  let prDetail = state.pr.prDetail;
  return {
    initialValues: {
      ...prDetail.data,
    },
    prData: prDetail.data,
    user: state.authen.user,
    members: state.member.members,
    memberLoading: state.member.memberLoading,
    valueForm: getFormValues("cancelPrForm")(state) || {},
  };
};

const mapDispatchToProps = {
  getHrmsMembers,
  cancelPr,
  cancelPrAndSap,
  getPRDetailByDocNo,
  clearPRCancelDetail
};

const validate = (values) => {
  let errors = {};
  validations(values, "docNumber", [vCase.require], errors);
  validations(values, "requester", [vCase.require], errors);
  validations(values, "reason", [vCase.require], errors);

  return errors;
};

const CancelPRForm = reduxForm({
  form: "cancelPrForm",
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(CancelPR);

export default connect(mapStateToProps, mapDispatchToProps)(CancelPRForm);
